import React from 'react'

import { Wrapper, P, H } from '@farewill/ui'
import { BREAKPOINT } from '@farewill/ui/tokens'

import BreakpointSwitch from 'components/BreakpointSwitch'
import ProductContact from 'components/ProductContact'

import { PRODUCTS } from 'lib/products/constants'

type CallUsProps = {
  data: {
    title: string
    description: string
    cta: string
  }
}

const CallUs = ({ data }: CallUsProps): React.ReactElement => (
  <Wrapper maxWidth={575} marginFromL={[0, 'auto']} centeredFromL>
    <H tag="h3" strong size="M" decorative>
      {data.title}
    </H>
    <P>{data.description}</P>
    <P strong size="L">
      {data.cta}
    </P>
    <BreakpointSwitch
      breakAt={BREAKPOINT.S}
      aboveComponent={
        <ProductContact
          selectedProduct={PRODUCTS.FUNERAL}
          hideCta
          showSpecialists
          highlightTelephoneNumber
        />
      }
      belowComponent={
        <ProductContact
          selectedProduct={PRODUCTS.FUNERAL}
          hideCta
          showSpecialists
          highlightTelephoneNumber
          telephoneNumberSize="medium"
        />
      }
    />
  </Wrapper>
)

export default CallUs
